import {
  type TableSearchProviderProps,
  useStateApi,
} from "./TableSearchContext";
import { TableSearchProviderValue } from "./TableSearchProviderValue";

export function TableSearchStateBackend(props: TableSearchProviderProps) {
  const value = useStateApi({
    defaultPageSize: props.defaultPageSize,
    searchDebounceMs: props.searchDebounceMs,
  });

  return (
    <TableSearchProviderValue value={value}>
      {props.children}
    </TableSearchProviderValue>
  );
}
